'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _actions = require('../actions');

var _paths = require('../vendor/paths');

var _Link = require('../components/UI/Link.jsx');

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    href: ownProps.file ? (0, _paths.filepath)(ownProps.file) : '#',
    children: ownProps.children || (ownProps.file ? ownProps.file.name : "(~)"),
    disabled: ownProps.disabled || !ownProps.file,
    selected: ownProps.file && state.audioPlayer.file && state.audioPlayer.file.id == ownProps.file.id
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onClick: function onClick() {
      if (!ownProps.file) return;
      switch (ownProps.file.type) {
        case 'audio':
          var file = ownProps.file;
          dispatch((0, _actions.audioPlayFile)(null));
          setTimeout(function () {
            dispatch((0, _actions.audioPlayFile)(ownProps.file));
          }, 10);
          break;
        case 'image':
          // document.body.style.backgroundImage = 
          break;
      }
    }
  };
};

var FileLink = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Link2.default);

exports.default = FileLink;


//////////////////
// WEBPACK FOOTER
// ./client/containers/fileLink.js
// module id = 33
// module chunks = 0